import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export interface FilteredCountIndicatorProps extends React.ComponentProps<'div'> {
	filteredCount?: number
	totalCount?: number
	isLoading?: boolean
	testId?: string
}

export function FilteredCountIndicator({
	filteredCount,
	totalCount,
	isLoading = false,
	testId,
	className,
	...props
}: FilteredCountIndicatorProps) {
	return (
		<div
			data-testid={testId}
			className={cn(
				'flex items-stretch rounded-md overflow-hidden border border-border h-control shrink-0 select-none text-control',
				className,
			)}
			{...props}>
			<div className='flex items-center px-2.5 bg-muted font-medium text-muted-foreground'>Filtered:</div>
			<div className='flex items-center px-2.5 bg-accent font-semibold text-accent-foreground border-l border-border min-w-[2.5rem] justify-center'>
				{isLoading ? (
					<Skeleton className='h-3.5 w-7 bg-muted-foreground/30 rounded-sm' />
				) : totalCount !== undefined ? (
					`${filteredCount ?? 0}/${totalCount}`
				) : (
					filteredCount
				)}
			</div>
		</div>
	)
}
